import React from 'react';
import ModelUpload from './ModelUpload';
import {MRAppRoutes, useRoute} from '../../router/routes';

const ModelUploadWrapper: React.FC = () => {
  const {uuid} = useRoute<MRAppRoutes.MODEL_UPLOAD>();
  return <ModelUpload key={uuid || ''} />;
};

export default ModelUploadWrapper;
